import { __assign, __extends } from "tslib";
import { noop } from 'lodash';
import React from 'react';
export var Context = React.createContext(null);
var VALIDATIONS = {
    required: function (val, isRequired) {
        if (!isRequired) {
            return;
        }
        if (!val || (typeof val === 'string' && val === '')) {
            throw new Error('This field is required');
        }
    },
    minLength: function (val, minLength) {
        if (!val || ("" + val).length < minLength) {
            throw new Error("This field must be at least " + minLength + " characters");
        }
    },
    maxLength: function (val, maxLength) {
        if (val && ("" + val).length > maxLength) {
            throw new Error("This field cannot be more than " + maxLength + " characters");
        }
    },
};
var Formbot = (function (_super) {
    __extends(Formbot, _super);
    function Formbot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            values: _this.props.initialValues || {},
            fields: {},
            errors: {},
        };
        _this.setValues = function (values) {
            if (values === void 0) { values = {}; }
            return new Promise(function (resolve) {
                _this.setState(function (state) { return ({
                    values: __assign(__assign({}, state.values), values),
                }); }, function () { return _this.validateAllFields().then(resolve); });
            });
        };
        _this.setErrors = function (errors, cb) {
            if (errors === void 0) { errors = {}; }
            return _this.setState(function (state) { return ({
                errors: __assign(__assign({}, state.errors), errors),
            }); }, cb);
        };
        _this.updateField = function (field, updates) {
            if (updates === void 0) { updates = {}; }
            return new Promise(function (resolve) {
                _this.setState(function (state) {
                    var _a;
                    return ({
                        fields: __assign(__assign({}, state.fields), (_a = {}, _a[field] = __assign(__assign({}, state.fields[field]), updates), _a)),
                    });
                }, resolve);
            });
        };
        _this.reset = function () {
            _this.setState({
                values: {},
                fields: {},
                errors: {},
            });
        };
        _this.onFocus = function (field) {
            _this.updateField(field, { focused: true }).then(function () {
                _this.props.onFocus(field);
            });
        };
        _this.onChange = function (field, value) {
            _this.setState(function (state) {
                var _a;
                return ({
                    values: __assign(__assign({}, state.values), (_a = {}, _a[field] = value, _a)),
                });
            }, function () {
                _this.updateField(field, { validated: false })
                    .then(function () { return _this.validateField(field); })
                    .then(function () { return _this.props.onChange(field, value, _this.state.values); });
            });
        };
        _this.onBlur = function (field) {
            _this.updateField(field, { blurred: true })
                .then(function () { return _this.validateField(field); })
                .then(function () {
                _this.props.onBlur(field);
            });
        };
        _this.onSubmit = function (event) {
            event.preventDefault();
            _this.validateAllFields().then(function () {
                _this.props.onSubmit({
                    isValid: _this.isValid,
                    values: _this.state.values,
                    errors: _this.state.errors,
                });
            });
        };
        return _this;
    }
    Object.defineProperty(Formbot.prototype, "validatableFields", {
        get: function () {
            var _a = this.props, validationSchema = _a.validationSchema, validations = _a.validations;
            return Object.keys(validationSchema || validations || {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Formbot.prototype, "validatable", {
        get: function () {
            return !!this.validatableFields.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Formbot.prototype, "isValid", {
        get: function () {
            return Object.values(this.state.errors).every(function (val) { return !val; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Formbot.prototype, "values", {
        get: function () {
            return this.state.values;
        },
        enumerable: false,
        configurable: true
    });
    Formbot.prototype.getValues = function () {
        var _this = this;
        return this.validateAllFields().then(function () { return ({
            isValid: _this.isValid,
            values: _this.values,
        }); });
    };
    Formbot.prototype.validateField = function (field) {
        var _this = this;
        return new Promise(function (resolve) {
            var fieldState = _this.state.fields[field] || {};
            if (fieldState.validated) {
                resolve();
                return;
            }
            var _a = _this.props, validationSchema = _a.validationSchema, validations = _a.validations;
            var hasSchema = !!validationSchema;
            var validation = (validationSchema || validations || {})[field];
            var validationOpts = { context: _this.getContext() };
            if (!validation) {
                resolve();
                return;
            }
            var fieldValue = _this.state.values[field];
            var setFieldValidated = function (message) {
                _this.updateField(field, { validated: true }).then(function () {
                    var _a;
                    _this.setErrors((_a = {}, _a[field] = message, _a), resolve);
                });
            };
            Promise.resolve()
                .then(function () {
                if (hasSchema && typeof validation.validate === 'function') {
                    return validation.validate(fieldValue, validationOpts);
                }
                if (typeof validation === 'function') {
                    validation(fieldValue);
                }
                else {
                    Object.keys(validation).forEach(function (method) {
                        var validator = VALIDATIONS[method];
                        if (!validator) {
                            throw new Error("Formbot: \"" + method + "\" is not a built-in validator.");
                        }
                        validator(fieldValue, validation[method]);
                    });
                }
                return true;
            })
                .then(function () {
                setFieldValidated();
            })
                .catch(function (err) {
                setFieldValidated(err.message);
            });
        });
    };
    Formbot.prototype.validateAllFields = function () {
        var _this = this;
        return Promise.all(this.validatableFields.map(function (field) {
            return _this.updateField(field, { validated: false }).then(function () { return _this.validateField(field); });
        }));
    };
    Formbot.prototype.getContext = function () {
        return __assign(__assign({}, this.props), { values: this.state.values, errors: this.state.errors, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onSubmit: this.onSubmit, reset: this.reset });
    };
    Formbot.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(Context.Provider, { value: this.getContext() }, typeof children === 'function' ? children(this.getContext()) : children));
    };
    Formbot.defaultProps = {
        initialValues: {},
        validations: {},
        validationSchema: null,
        onFocus: noop,
        onChange: noop,
        onBlur: noop,
        onSubmit: noop,
    };
    return Formbot;
}(React.Component));
export { Formbot };
//# sourceMappingURL=Formbot.js.map